<template>
  <div>
    <AdminNavbar />
    <div v-if="!isReady">
      <div class="d-flex justify-content-center">
        <div class="col col-sm-8 col-md-6">
          <LoadingBar />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container mt-3">
        <div class="d-flex">
          <div class="col col-sm-8 col-md-6">
            <div class="card text-start shadow-sm">
              <div class="card-header fs-4 fw-bold">Glossaries</div>
              <div class="card-body p-0">
                <table class="table table-striped border mb-1">
                  <thead>
                    <tr>
                      <th scope="col" class="ps-3">Glossary</th>
                      <th scope="col" class="pe-3 text-end">Link</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="ps-3 align-middle">Achievements</td>
                      <td class="ps-3 align-middle text-end">
                        {{ getAchievementsGlossaryLink }}
                        <a
                          :href="getAchievementsGlossaryLink"
                          target="_blank"
                          class="btn btn-primary fw-bold"
                          >Visit</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="ps-3 align-middle">Questions</td>
                      <td class="ps-3 align-middle text-end">
                        {{ getQuestionsGlossaryLink }}
                        <a
                          :href="getQuestionsGlossaryLink"
                          target="_blank"
                          class="btn btn-primary fw-bold"
                          >Visit</a
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="ps-3 align-middle">Awarded Points</td>
                      <td class="ps-3 align-middle text-end">
                        {{ getAwardedPointsGlossaryLink }}
                        <a
                          :href="getAwardedPointsGlossaryLink"
                          target="_blank"
                          class="btn btn-primary fw-bold"
                          >Visit</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <CustomAlert
          v-if="0"
          title="Content"
          type="warning"
          icon="bi-exclamation-circle"
        >
          <p class="mb-0">Under development.</p>
        </CustomAlert>
        <!-- Admin Content Start -->

        <div class="card text-start shadow-sm" v-if="0">
          <div class="card-header">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="fs-4 mx-0 fw-bold">Manage {{ remappedName }}</div>
                <div class="fst-italic d-none">
                  Add, edit, or delete your content.
                </div>
              </div>
              <button
                class="btn btn-success fs-4 py-0 px-2"
                @click="openAddPopup"
              >
                <i class="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <div class="card-body p-0">
            <table class="table table-striped border mb-1">
              <thead>
                <tr>
                  <th scope="col" class="ps-3 d-none">Name</th>
                  <th scope="col" class="ps-3">Message</th>
                  <th scope="col" class="pe-3 text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in content" :key="item.id">
                  <td class="ps-3 align-middle d-none">{{ item.id }}</td>
                  <td class="ps-3 align-middle">{{ item.value }}</td>
                  <td class="pe-3 align-middle text-end">
                    <button
                      class="btn btn-warning btn-sm me-1"
                      aria-label="Edit"
                      @click="openEditPopup(item)"
                      title="Edit"
                    >
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button
                      class="btn btn-danger btn-sm"
                      aria-label="Delete"
                      @click="removeItem(item)"
                      title="Delete"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Admin Content End -->
      </div>
    </div>
    <!-- Add Modal -->
    <div
      class="modal fade"
      id="addModal"
      tabindex="-1"
      aria-labelledby="addModalLabel"
      aria-hidden="true"
      ref="addModal"
    >
      <div class="modal-dialog text-start">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="addModalLabel">
              Add New {{ remappedName }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!--<div class="mb-3">
              <label for="newName" class="form-label fw-bold">Name</label>
              <input
                type="text"
                id="newName"
                class="form-control"
                v-model="newName"
              />
            </div>-->
            <div class="">
              <label for="newDescription" class="form-label fw-bold"
                >Value</label
              >
              <textarea
                type="text"
                id="newDescription"
                class="form-control"
                v-model="formFields.value"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary d-none"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button type="button" class="btn btn-success" @click="addItem">
              Add
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <div
      class="modal fade"
      id="editModal"
      tabindex="-1"
      aria-labelledby="editModalLabel"
      aria-hidden="true"
      ref="editModal"
    >
      <div class="modal-dialog text-start">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fw-bold" id="editModalLabel">
              Edit {{ remappedName }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3" v-if="0">
              <label for="editName" class="form-label fw-bold">Name</label>
              <input
                type="text"
                id="editName"
                class="form-control"
                v-model="formFields.name"
              />
            </div>
            <div class="">
              <label for="editDescription" class="form-label fw-bold"
                >Message</label
              >
              <textarea
                type="text"
                id="editDescription"
                class="form-control"
                v-model="formFields.value"
              ></textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary d-none"
              data-bs-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="saveEditedItem"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AdminNavbar from "@/admin/components/AdminNavbar.vue";
import CustomAlert from "@/components/ui/CustomAlert.vue";
import LoadingBar from "@/components/ui/LoadingBar.vue";
import { Modal } from "bootstrap";
import { nameMapping } from "@/admin/index";

import {
  readContentEntries,
  createContentEntry,
  updateContentEntry,
  deleteContentEntry
} from "@/apis/content";

export default {
  name: "SettingsView",
  components: {
    AdminNavbar,
    CustomAlert,
    LoadingBar
  },
  data() {
    return {
      isReady: false,
      content: [],
      formFields: {
        id: "",
        value: ""
      },
      addModalInstance: null,
      editModalInstance: null
    };
  },
  computed: {
    ...mapGetters([
      "getAchievementsGlossaryLink",
      "getQuestionsGlossaryLink",
      "getAwardedPointsGlossaryLink"
    ]),
    remappedName() {
      let routeName = this.$route.name;
      return nameMapping[routeName] || routeName;
    }
  },
  methods: {
    resetFormFields() {
      this.formFields.id = "";
      this.formFields.value = "";
    },
    openAddPopup() {
      this.resetFormFields();
      if (this.addModalInstance) {
        this.addModalInstance.show();
      } else {
        console.error("Add modal instance not initialized.");
      }
    },
    addItem() {
      if (!this.formFields.value.trim()) {
        alert("Please fill out all fields before submitting.");
        return;
      }

      this.formFields.id = Date.now().toString();

      createContentEntry(this.formFields)
        .then(() => {
          this.content.push({ ...this.formFields });
          console.log("Item added successfully.");
        })
        .catch((error) => {
          alert("Failed to add item. Check logs for details.");
          console.error(error);
        })
        .finally(() => {
          this.resetFormFields();
          this.addModalInstance.hide();
        });
    },
    openEditPopup(item) {
      this.resetFormFields();
      console.log(item);
      this.formFields = { ...this.formFields, ...item }; // todo -- lets watch this to make sure formFields
      if (this.editModalInstance) {
        this.editModalInstance.show();
      } else {
        console.error("Edit modal instance not initialized.");
      }
    },
    saveEditedItem() {
      const index = this.content.findIndex((i) => i.id === this.formFields.id);
      if (index === -1) {
        return;
      }

      updateContentEntry(this.formFields)
        .then(() => {
          this.content[index] = { ...this.formFields };
          console.log("Item updated successfully.");
        })
        .catch((error) => {
          alert("Failed to update item. Check logs for details.");
          console.error(error);
        })
        .finally(() => {
          this.resetFormFields();
          this.editModalInstance.hide();
        });
    },
    removeItem(item) {
      if (!confirm("Are you sure you want to delete this item?")) {
        return;
      }

      const uidKey = "id";
      const uidValue = item.id;
      const page = "Sheet1";

      deleteContentEntry(uidKey, uidValue, page)
        .then(() => {
          //
          // Filter locally, without having to refetch the data.
          //
          this.content = this.content.filter((i) => i.id !== item.id);
          console.log("Item deleted successfully.");
        })
        .catch((error) => {
          alert("Failed to delete item. Check logs for details.");
          console.error(error);
        });
    }
  },
  mounted() {
    this.addModalInstance = new Modal(this.$refs.addModal);
    this.editModalInstance = new Modal(this.$refs.editModal);
  },
  created() {
    this.isReady = false;

    readContentEntries("Sheet1")
      .then((response) => {
        this.content = response?.data?.message || [];
        console.log("Content fetched successfully.");
      })
      .catch((error) => {
        console.error("Error fetching content:", error);
      })
      .finally(() => {
        this.isReady = true;
      });
  }
};
</script>
